export default "__VITE_ASSET__CcQeYD2R__"